/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { Flex } from '@chakra-ui/react'
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'

interface iProps{
  id: string
  Grafico: iGraficoColuna
}

interface iGraficoColuna{
  eixoX: string[]
  medias: number[]
}

export const ColumnChart: React.FC<iProps> = ({ id, Grafico }) => {
  function GerarGrafico(): void {
    const options = {
      series: [{
        name: '',
        data: Grafico.medias
      }],
      grid: {
        show: false
      },
      chart: {
        type: 'bar'
      },
      plotOptions: {
        bar: {
          color: '#4472C4',
          columnWidth: '80%',
          dataLabels: {
            position: 'top'
          }
        }
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: number) {
            return val.toFixed(2)
          }
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '12px',
          colors: ['#58544D']
        },
        offsetY: -20,
        formatter: function(value: number): string {
          return `${value.toFixed(2)}`
        }
      },
      // title: {
      //   text: 'Separado por'
      // },
      annotations: {
        yaxis: [
          {
            y: 0,
            strokeDashArray: 0,
            borderColor: 'var(--c5)',
            fillColor: '#c2c2c2',
            opacity: 0.8,
            offsetX: 0,
            offsetY: 0
          }
        ]
      },
      yaxis: {
        show: false
        // labels: {
        //   formatter: function (y: any) {
        //     return y.toFixed(0) + '%'
        //   }
        // }
      },
      xaxis: {
        categories: Grafico.eixoX
      }
    }
    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    chart.render()

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    chart.updateSeries([{
      name: '',
      data: Grafico.medias
    }])
  }

  useEffect(() => {
    GerarGrafico()
  }, [Grafico])
  return (
        <Flex width={'100%'} id={`chart-${id}`}/>
  )
}
